export const formatQueryStringURL = (url = '') => {
	if (!url) {
		return;
	}
	return url.replace('?&', '?').replace('&&', '&');
};
